import React from 'react';

const Portfolio2 = () => {

  return (
    <section className="portfolio" id="portfolio">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">Portfólio</h2>
        
        <div className="instagram-embed" data-aos="fade-up" data-aos-delay="200">
          <div className="instagram-placeholder">
            <div className="instagram-header">
              <i className="fab fa-instagram"></i>
              <span>@paradiseformaturas</span>
            </div>
            
            <div className="instagram-alternatives">
              {/* Método 1: Instagram Embed Iframe */}
              <div className="instagram-method instagram-iframe-method">
                <iframe 
                  src="https://www.instagram.com/paradiseformaturas/embed" 
                  width="100%" 
                  height="800"
                  frameBorder="0"
                  title="Instagram Paradise Formaturas"
                  loading="lazy"
                ></iframe>
              </div>

            </div>
            
            <div className="instagram-btn-wrapper">
              <a 
                href="https://www.instagram.com/paradiseformaturas/" 
                className="instagram-btn" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
                <span>Ver mais no Instagram</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio2;